import { OrderedMap } from "immutable";
import useLayoutVariant from "components/common/PaginatedEntityTable/hooks/useLayoutVariant";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
import {
  fetchInvestigationSlices,
  searchInvestigationKeyFC,
  searchInvestigations
} from "security-app/hooks/api/investigationsAPI";
import AssigneeFilter from "./filters/AssigneeFilter";
export const INVESTIGATION_ATTRIBUTES = {
  created_at: { title: "Started At", sortable: true, filterable: true },
  assigned_to: { title: "Assigned To", sortable: true, filterable: true },
  name: { title: "Name", sortable: true, filterable: true },
  priority: { title: "Priority", sortable: true, filterable: true },
  status: { title: "Status", sortable: true, filterable: true },
  updated_at: { title: "Last Update", sortable: true, filterable: true }
};
export const INVESTIGATIONS_VIEWS = {
  ACTIVE: "",
  ARCHIVED: "archived"
};
export const INVESTIGATIONS_VIEWS_VARIANTS = [
  {
    label: "Active",
    value: INVESTIGATIONS_VIEWS.ACTIVE
  },
  {
    label: "Archived",
    value: INVESTIGATIONS_VIEWS.ARCHIVED
  }
];
export const INVESTIGATIONS_TABLE_ID = "investigations_list";
export const isArchivedView = (layoutVariant) => layoutVariant === INVESTIGATIONS_VIEWS.ARCHIVED;
export const useInvestigationsTableElements = () => {
  const { activeLayoutVariant } = useLayoutVariant();
  const defaultColumnOrder = [
    "name",
    "priority",
    "status",
    "assigned_to",
    "created_at",
    "updated_at",
    "source_type",
    "has_agent_initial_assessment"
  ];
  const defaultDisplayedAttributes = defaultColumnOrder;
  return {
    defaultLayout: {
      entityTableId: INVESTIGATIONS_TABLE_ID,
      layoutVariant: activeLayoutVariant,
      defaultPageSize: 20,
      defaultSort: { attributeId: "created_at", direction: "desc" },
      defaultDisplayedAttributes,
      defaultColumnOrder
    }
  };
};
const ARCHIVED_ATTRIBUTE = "archived";
export const useInvestigationsEntityTableDefaultFilters = (entityTableId) => {
  const { activeLayoutVariant } = useLayoutVariant();
  const {
    data: { defaultFilters }
  } = useUserLayoutPreferences(entityTableId, activeLayoutVariant);
  return defaultFilters == null ? void 0 : defaultFilters.remove(ARCHIVED_ATTRIBUTE);
};
const withArchivedFilter = (filters, layoutVariant) => (filters != null ? filters : OrderedMap()).set(ARCHIVED_ATTRIBUTE, [String(isArchivedView(layoutVariant))]);
const SLICEABLE_ATTRIBUTES = /* @__PURE__ */ new Set(["priority", "status", "assigned_to"]);
const FILTER_COMPONENTS = {
  assigned_to: AssigneeFilter
};
export const withInvestigationAttributeFlags = (response) => ({
  ...response,
  attributes: response.attributes.map((attribute) => {
    var _a;
    return {
      ...attribute,
      sliceable: SLICEABLE_ATTRIBUTES.has(attribute.id),
      // The backend needs the archived attribute to be filterable, but only the layout variant may filter on it.
      filterable: attribute.id === ARCHIVED_ATTRIBUTE ? false : attribute.filterable,
      filter_component: (_a = FILTER_COMPONENTS[attribute.id]) != null ? _a : attribute.filter_component
    };
  })
});
export const investigationsTableFetchers = (layoutVariant) => {
  const withLayoutVariantFilters = (searchParams) => ({
    ...searchParams,
    filters: withArchivedFilter(searchParams.filters, layoutVariant)
  });
  return {
    keyFn: (searchParams) => searchInvestigationKeyFC(withLayoutVariantFilters(searchParams)),
    fetchEntities: async (searchParams) => withInvestigationAttributeFlags(await searchInvestigations(withLayoutVariantFilters(searchParams))),
    fetchSlices: (column, query, filters) => fetchInvestigationSlices(column, query, withArchivedFilter(filters, layoutVariant))
  };
};
